import { createAction } from 'redux-actions';

import { reduxKey } from '../../constants';

export const setBlockedUsernamesWidgetBlockedUsers = createAction(
  `${reduxKey}.SET_BLOCKEDUSERNAMES_WIDGET_BLOCKED_USERS`,
  (blockedUsernames: string[]) => ({ blockedUsernames })
);

export const saveBlockedUsernames = createAction(
  `${reduxKey}.SAVE_BLOCKED_USERNAMES`,
  () => ({})
);

export const saveBlockedUsernamesSuccess = createAction(
  `${reduxKey}.SAVE_BLOCKED_USERNAMES_SUCCESS`,
  () => ({})
);

export const saveBlockedUsernamesFailure = createAction(
  `${reduxKey}.SAVE_BLOCKED_USERNAMES_FAILURE`,
  (errorMessage: string) => ({ errorMessage })
);
